import { CartItemViewModel, ProductVariantViewModel } from '@/types/api'

import { productNameSizeHandler } from './product-name-size-handler'

import { KeyPathType } from '../types'

export function multiStringHandler(variants: ProductVariantViewModel[], keyPath: KeyPathType) {
    if (!keyPath.trim() || !variants.length) return ''

    if (keyPath === KeyPathType.discount) {
        const discounts = variants
            .map((variant) => {
                const isGift = (variant as CartItemViewModel).gift
                const base = variant.basePrice
                const sales = isGift ? 0 : variant.salesPrice

                if (typeof base !== 'number' || typeof sales !== 'number') return 'Blank'

                const discount = base - sales
                return discount === 0 ? 0 : discount
            })
            .filter((v) => v !== undefined && v !== null)

        return discounts.join(', ')
    }

    const keys = keyPath.split('.')

    const values = variants
        .map((variant) => {
            const isGift = (variant as CartItemViewModel).gift
            let value = variant
            for (const key of keys) {
                value = value?.[key as keyof object]
                if (value === undefined || value === null) return 'Blank'
            }

            if (typeof value === 'string' && value === '') {
                return 'Blank'
            }

            if (keyPath === KeyPathType.productName) {
                return productNameSizeHandler(value as string, 20)
            }

            if (keyPath === KeyPathType.salesPrice) {
                return isGift ? 0 : value
            }

            return value
        })
        .filter((v) => v !== undefined && v !== null)

    return values.join(', ')
}
